"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _spacing = require("../../fuse-spacing/src/spacing");
var _typography = require("../../fuse-typography/src/typography");
var _styledSkeleton = _interopRequireDefault(require("./styled-skeleton"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var spacingList = Object.keys(_spacing.globalSpacingTokens).filter(function (value) {
  return !value.includes('em');
});
var lineHeightList = Object.keys(_typography.defaultCssProps).map(function (key) {
  return key.replace('t', '');
});
var fuseLineHeights = _propTypes["default"].oneOf(lineHeightList);
var fuseSpaceValues = _propTypes["default"].oneOf(spacingList);
var propTypes = {
  className: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  height: _propTypes["default"].shape({
    s: _propTypes["default"].string,
    m: _propTypes["default"].string,
    l: _propTypes["default"].string
  }),
  lineHeight: fuseLineHeights,
  margin: _propTypes["default"].shape({
    top: fuseSpaceValues,
    right: fuseSpaceValues,
    bottom: fuseSpaceValues,
    left: fuseSpaceValues
  }),
  noBorderRadius: _propTypes["default"].bool,
  size: _propTypes["default"].string,
  variant: _propTypes["default"].oneOf(['text', 'circle', 'rect']),
  width: _propTypes["default"].shape({
    s: _propTypes["default"].string,
    m: _propTypes["default"].string,
    l: _propTypes["default"].string
  })
};
var defaultProps = {
  className: undefined,
  dataTestId: 'fuse-skeleton-test-id',
  height: undefined,
  lineHeight: undefined,
  margin: {},
  noBorderRadius: undefined,
  size: undefined,
  variant: 'rect',
  width: undefined
};
function SkeletonBase(props) {
  return /*#__PURE__*/_react["default"].createElement(_styledSkeleton["default"], props);
}
SkeletonBase.propTypes = propTypes;
SkeletonBase.defaultProps = defaultProps;
var _default = exports["default"] = SkeletonBase;